var React = require('react');

function ArcTopIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.66118 46.3646C5.66118 46.3646 43.435 6.85653 78.5075 2.23508","stroke":"white","strokeWidth":"3","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M46.1003 29.1046C46.1003 29.1046 67.4925 13.7656 78.8396 13.6826","stroke":"white","strokeWidth":"3","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArcTopIcon.defaultProps = {"width":"84","height":"48","viewBox":"0 0 84 48","fill":"none"};

module.exports = ArcTopIcon;

ArcTopIcon.default = ArcTopIcon;
